import { IconPropsType } from '..';

export const UserFilledIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5461_58381)">
      <path
        d="M6.99995 0.700195C3.52019 0.700195 0.699951 3.52043 0.699951 7.0002C0.699951 10.48 3.52019 13.3002 6.99995 13.3002C10.4797 13.3002 13.3 10.48 13.3 7.0002C13.3 3.52043 10.4797 0.700195 6.99995 0.700195ZM6.99995 3.8502C7.97867 3.8502 8.77183 4.6436 8.77183 5.62207C8.77183 6.60054 7.9794 7.39395 6.99995 7.39395C6.02148 7.39395 5.22808 6.60054 5.22808 5.62207C5.22808 4.6436 6.0205 3.8502 6.99995 3.8502ZM6.99995 11.7252C5.69738 11.7252 4.51687 11.1954 3.66046 10.3399C4.05913 9.31102 5.04351 8.5752 6.21245 8.5752H7.78745C8.95738 8.5752 9.94176 9.31052 10.3394 10.3399C9.48304 11.1961 8.30179 11.7252 6.99995 11.7252Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5461_58381">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
